import { combineReducers } from 'redux';
// Reducers
import login from './reducers/loginReducer';

export default combineReducers({
    login,
});
